<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addTrain()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.trains.length == 0"
  message="Per questo itinerario non è ancora stato inserito alcun treno."
  actionIcon="add"
  actionLabel="Aggiungi un treno"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
  (actionClick)="addTrain()"
>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let train of itinerary.reservations.trains; index as trainId"
    [(expanded)]="expanded[trainId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">directions_transit</mat-icon>
        <span class="header-title" fxFlex
          ><app-itinerary-reservations-transportation-form-title
            [transportation]="train"
          ></app-itinerary-reservations-transportation-form-title
        ></span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questo treno'"
            (click)="removeTrain($event, train)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-transportation-form
      [transportation]="train"
      [transportationId]="trainId"
      [stopsFormFieldLabel]="'Fermate'"
      [detailFormFieldLabel]="'stazione'"
      [showCodeFormField]="false"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-reservations-transportation-form>
  </mat-expansion-panel>
</mat-accordion>
